import React from "react";
import { Card, Typography } from "antd";

const { Text } = Typography;

interface CapabilityTileProps {
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
  onDoubleClick?: () => void;
}

/**
 * A benchmark "target" tile (a classify capability or a standalone capability), styled to match the
 * Agent step's AgentTile: an antd hoverable Card with a blue border when selected, so the whole tab
 * has one consistent, compact tile look and a single sensible hover affordance.
 */
export const CapabilityTile: React.FC<CapabilityTileProps> = ({
  title,
  description,
  selected,
  onSelect,
  onDoubleClick,
}) => (
  <Card
    hoverable
    style={{
      borderColor: selected ? "#1890ff" : undefined,
      borderWidth: selected ? 2 : 1,
      height: "100%",
    }}
    onClick={onSelect}
    onDoubleClick={onDoubleClick}
  >
    <Card.Meta
      title={<span style={{ whiteSpace: "normal" }}>{title}</span>}
      description={<Text type="secondary">{description}</Text>}
    />
  </Card>
);
